import {EntityType} from "../@core/entityType";

export const entityType = EntityType.License;
export const entityOperations = [];
